<template>
    <div>

        <div class="dropdown-mobile">
            <!-- <span class="e-resulttext">{{resultCount}} {{resultsCountLabel}}</span> -->
            <button class="top-toggle">Filter by:</button>
            <div class="filters">

                <div class="e-close">
                    Close
                </div>

                <h2 class="text-scale-base text-dark-blue leading-base">Refine results</h2>

                <span class="results">{{resultCount}} {{resultsCountLabel}}</span>

                <template v-if="searchFilters.ShowKeywordFilter">
                    <div class="keyword">
                        <label for="searchFilterKeywordsMobile" class="visually-hidden">Search by keyword</label>
                        <input type="text"
                               id="searchFilterKeywordsMobile"
                               name="keywords"
                               placeholder="Search by keyword..."
                               v-model="keywords"
                               >
                        <button type="submit" class="keyword__search-btn">
                            <span class="search-icon">
                                <svg aria-hidden="true" viewBox="0 0 24 24">
                                    <path d="M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z"/>
                                </svg>
                            </span>
                            <span class="visually-hidden">Submit search</span>
                        </button>
                    </div>
                </template>

                <active-filters :search-filters="searchFilters" v-if="searchFilters.FilterList && searchFilters.FilterList.Filters && searchFilters.FilterList.Filters.length > 0"></active-filters>

                <template v-if="searchFilters && searchFilters.FilterList && searchFilters.FilterList.Filters">
                    <div class="dropdown" v-for="(filter, index) in searchFilters.FilterList.Filters" :key="index" :id="'dropdown-sml-' + index">
                        <div class="dropdown__header">
                            <h3 class="dropdown__title">
                                <button ref="'dropdownTrigger' + index" @click="toggleCollapsible($event, index)" class="dropdown__title-btn" aria-expanded="false" :aria-controls="'mobile-dropdown-panel-' + filter.Id">
                                    <span>{{filter.Name}}</span>
                                    <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
                                </button>
                            </h3>
                        </div>
                        <div :id="'mobile-dropdown-panel-' + filter.Id" class="dropdown__body" :class="{ 'js-expanded': index === activeItem }">
                            <div class="dropdown__filters">
                                <ul>
                                    <li v-for="filterTag in filter.FilterTags" :key="filterTag.Tag.Id">
                                        <div class="dropdown__checkbox">
                                            <input class="filter-picker"
                                                :id="'mobile-tag-' + filterTag.Tag.Id"
                                                :name="formatFilterName(filter)"
                                                type="checkbox"
                                                v-model="filters[formatFilterName(filter)]"
                                                v-on:change="filtersChanged"
                                                :value="filterTag.Tag.Id" 
                                                :data-filtername="filterTag.Tag.Name" 
                                                :data-filtercategory="filter.Name" />
                                            <label :for="'mobile-tag-' + filterTag.Tag.Id">
                                                {{filterTag.Tag.Name}}
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>

                <div class="filters__action">
                    <button class="btn close-filters-panel" role="button">Show updated results</button>
                </div>
            </div>
        </div>
        
        <active-filters :search-filters="searchFilters" v-if="searchFilters.FilterList && searchFilters.FilterList.Filters && searchFilters.FilterList.Filters.length > 0"></active-filters>
        
        <template v-if="searchFilters.ShowKeywordFilter">
            <div class="keyword">
                <label for="searchFilterKeywords" class="visually-hidden">Keyword search</label>
                <input class="keyword__input" type="text"
                       id="searchFilterKeywords"
                       name="keywords"
                       placeholder="Keyword search"
                       v-model="keywords"
                       >
                <button type="submit" class="keyword__search-btn">
                    <span class="search-icon">
                        <svg aria-hidden="true" viewBox="0 0 24 24">
                            <path d="M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z"/>
                        </svg>
                    </span>
                    <span class="visually-hidden">Submit search</span>
                </button>
            </div>
        </template>

        <div class="dropdown-container">
            <template v-if="searchFilters && searchFilters.FilterList && searchFilters.FilterList.Filters">
                <div class="dropdown" v-for="(filter, index) in searchFilters.FilterList.Filters" :key="index" :id="'dropdown-lrg-' + index">
                    <div class="dropdown__header">
                        <h3 class="dropdown__title">
                            <button ref="'dropdownTrigger' + index" @click="toggleCollapsible($event, index)" class="dropdown__title-btn" aria-expanded="false" :aria-controls="'dropdown-panel-' + filter.Id">
                                <span>{{filter.Name}}</span>
                                <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
                            </button>
                        </h3>
                    </div>
                    <div :id="'dropdown-panel-' + filter.Id" class="dropdown__body" :class="{ 'js-expanded': index === activeItem }">
                        <div class="dropdown__filters">
                            <ul>
                                <li v-for="filterTag in filter.FilterTags" :key="filterTag.Tag.Id">
                                    <div class="dropdown__checkbox">
                                        <input class="filter-picker"
                                            :id="'tag-' + filterTag.Tag.Id"
                                            :name="formatFilterName(filter)"
                                            type="checkbox"
                                            v-model="filters[formatFilterName(filter)]"
                                            v-on:change="filtersChanged"
                                            :value="filterTag.Tag.Id"
                                            :data-filtername="filterTag.Tag.Name"
                                            :data-filtercategory="filter.Name" />
                                        <label :for="'tag-' + filterTag.Tag.Id">
                                            {{filterTag.Tag.Name}}
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'
    import { globalMixin } from '@/mixins/globalMixin.js'
    import ActiveFilters from '@/components/SiteSearch/search-active-filters'

    export default {
        components: {
            ActiveFilters
        },
        emits: ['filters-loaded'],
        computed: {
            // This computed property gets the whole filters object from the store for the checkboxes
            filters() {
                return this.$store.state.search.filters
            },

    
            keywords: {
                get() {
                    return this.$store.state.search.filters.keywords
                },
                set(value) {
              
                    this.$store.dispatch('updateSearchFilter', { key: 'keywords', value })
                    this.triggerSearch()
                }
            },

            resultCount: function () {
                return this.$store.state.search.resultCount
            },

            resultsLoaded: function () {
                return this.$store.state.search.resultsLoaded
            }
        },

        created: function () {
            this.init()
        },

        data() {
            return {
                activeDropdownKey: null,
                activeMobile: false,
                date: this.$store.state.search.filters.date,
                filterTimeout: null,
                loading: false,
                selectedFilters: {},
                searchFilters: {},
                updatingFilters: false,
                activeItem: null
            }
        },



        methods: {
            triggerSearch() {
                if (this.filterTimeout) {
                    clearTimeout(this.filterTimeout)
                }
                this.filterTimeout = setTimeout(() => {
                    this.$eventHub.$emit('search-filtersChanged')
                }, 500)
            },
            // This method is now only for the checkboxes, which call it on @change
            filtersChanged() {
                Object.keys(this.searchFilters.FilterList.Filters).forEach(i => {
                    const filter = this.searchFilters.FilterList.Filters[i]
                    const filterName = this.formatFilterName(filter)
                    this.$store.dispatch('updateSearchFilter', {
                        key: filterName,
                        value: this.filters[filterName]
                    })
                })
                this.triggerSearch()
            },

            toggleCollapsible(event, i) {
                if (event && event.preventDefault) {
                    event.preventDefault()
                    const toggleLink = event.currentTarget
                    const state = toggleLink.getAttribute('aria-expanded')
                    const allToggles = document.querySelectorAll('.dropdown__title-btn')

                    if (state === 'false') {
                        allToggles.forEach(el => el.setAttribute('aria-expanded', false))
                        toggleLink.setAttribute('aria-expanded', true)
                        this.activeItem = i
                    } else {
                        toggleLink.setAttribute('aria-expanded', false)
                        this.activeItem = null
                    }
                }
            },

            onBlur: function () {
                this.isVisible = null
            },

            formatFilterName: function (filter) {
                return 'filter_' + filter.Id
            },

            init: function () {
                var vm = this
                vm.loading = true

                const getSearchFilters = function () {
                    const url = '/umbraco/api/SearchApi/SearchFilters'
                    const params = { currentPageId: currentPageId }
                    return Axios.get(url, { params })
                }

                Axios.all([getSearchFilters()])
                    .then(
                        Axios.spread(function (searchFilters) {
                            vm.searchFilters = searchFilters.data
                            vm.$emit('filters-loaded', searchFilters.data)
                            vm.$store.commit('setAllAvailableFilters', searchFilters.data)

                            if (
                                vm.searchFilters &&
                                vm.searchFilters.FilterList &&
                                vm.searchFilters.FilterList.Filters
                            ) {
                                vm.searchFilters.FilterList.Filters.forEach(function (filter) {
                                    const filterName = vm.formatFilterName(filter)

                                    if (!vm.filters.hasOwnProperty(filterName)) {
                                        const selectedTags = filter.FilterTags.filter(
                                            (filterTag) => filterTag.IsSelected
                                        )
                                        const selectedTagIds = selectedTags.map(
                                            (filterTag) => filterTag.Tag.Id
                                        )
                                        vm.$store.dispatch('addSearchFilter', {
                                            filterName: filterName,
                                            initialValue: selectedTagIds, 
                                        })
                                    }
                                
                                })
                            }
                            vm.loading = false
                        })
                    )
                    .catch(() => {
                        vm.loading = false
                    })
            }
        },

        mounted: function () {
            this.toggleCollapsible()
        },

        mixins: [globalMixin],

        props: {
            resultsCountLabel: {
                default: 'results',
                type: String
            },
            showResultsCount: {
                default: true,
                type: Boolean
            }
        }
    }
</script>
